import React from 'react';

import DecimalForConceptos from '../../../../support/impuestos/DecimalForConceptos';

const ConceptoRetencion = ({ data }) => {
  return (
    <div>
      { data.Impuesto } { data.TasaOCuota }

      { data.TipoFactor === 'Exento' && (
        <span> Exento </span>
      )}

      { data.TipoFactor !== 'Exento' && (
        <span>
          { ' | ' }
          { DecimalForConceptos.make(data.Importe).toString() }
        </span>
      )}
      <br/>
      <br/>
    </div>
  )
}

const ConceptoRetenciones = ({ data = [] }) => {

  const renderRetencion = (item) => {
    return <ConceptoRetencion key={ `R-${item.Impuesto}` } data={ item } />
  }

  return (
    <>
      { data.length > 0 && (
        <div>
          <strong>Retenciones: </strong>
          <br/>
          { data.map(renderRetencion) }
        </div>
      )}
    </>
  )
}

export default ConceptoRetenciones
